// The easing function that makes the scroll decelerate over time
function easeOutQuart(x: number) {
  return 1 - Math.pow(1 - x, 4);
}

export const animateScroll = (
  targetEl: HTMLElement,
  offset: number = 0,
  callback: Function = () => {},
  duration: number = 1000,
  initialPosition: number = window.scrollY
) => {
  let start: number | null = null;
  let position = 0;
  let animationFrame: number;

  const requestAnimationFrame = window.requestAnimationFrame;
  const cancelAnimationFrame = window.cancelAnimationFrame;

  // maximum amount of pixels we can scroll
  const maxAvailableScroll = document.documentElement.scrollHeight - document.documentElement.clientHeight;

  const endPosition = targetEl.getBoundingClientRect().top + window.scrollY + offset;

  const amountOfPixelsToScroll = initialPosition - endPosition;

  function step(timestamp: number) {
    if (start === null) {
      start = timestamp;
    }

    const elapsed = timestamp - Number(start);

    // this just gives us a number between 0 (start) and 1 (end)
    const relativeProgress = elapsed / duration;

    // ease out that number
    const easedProgress = easeOutQuart(relativeProgress);

    // calculate new position for every thick of the requesAnimationFrame
    position = initialPosition - amountOfPixelsToScroll * Math.min(easedProgress, 1);

    // set the scrollbar position
    window.scrollTo(0, position);

    // Stop when max scroll is reached
    if (initialPosition !== maxAvailableScroll && window.scrollY >= maxAvailableScroll) {
      cancelAnimationFrame(animationFrame);
      callback();
      return;
    }

    // repeat until the end is reached
    if (elapsed < duration) {
      animationFrame = requestAnimationFrame(step);
    } else {
      callback();
    }
  }
  animationFrame = requestAnimationFrame(step);
};

export const animateElementScroll = (
  direction: "x" | "y",
  targetEl: HTMLElement,
  endPosition: number,
  callback: Function = () => {},
  duration: number = 250
) => {
  let start: number | null = null;
  let position = 0;
  let animationFrame: number;

  const { requestAnimationFrame, cancelAnimationFrame } = window;
  const initialPosition = direction === "x" ? targetEl.scrollLeft : targetEl.scrollTop;

  // maximum amount of pixels we can scroll
  const maxAvailableScroll =
    direction === "x"
      ? targetEl.scrollWidth - targetEl.clientWidth
      : targetEl.scrollHeight - targetEl.clientHeight;

  const amountOfPixelsToScroll = initialPosition - endPosition;

  function step(timestamp: number) {
    if (start === null) {
      start = timestamp;
    }

    const elapsed = timestamp - Number(start);

    // this just gives us a number between 0 (start) and 1 (end)
    const relativeProgress = elapsed / duration;

    // ease out that number
    const easedProgress = relativeProgress;

    // calculate new position for every thick of the requesAnimationFrame
    position = initialPosition - amountOfPixelsToScroll * Math.min(easedProgress, 1);

    // set the scrollbar position
    if (direction === "x") {
      targetEl.scrollTo(position, 0);
    } else {
      targetEl.scrollTo(0, position);
    }

    // Stop when max scroll is reached
    if (
      initialPosition !== maxAvailableScroll &&
      (direction === "x"
        ? targetEl.scrollLeft >= maxAvailableScroll
        : targetEl.scrollTop >= maxAvailableScroll)
    ) {
      cancelAnimationFrame(animationFrame);
      callback();
      return;
    }

    // repeat until the end is reached
    if (elapsed < duration) {
      animationFrame = requestAnimationFrame(step);
    } else {
      callback();
    }
  }
  animationFrame = requestAnimationFrame(step);
};
